export const NEXT_PAGE = "NEXT_PAGE"
export const PREVIOUS_PAGE = "PREVIOUS_PAGE"
export const PAGE_TARGET = "PAGE_TARGET"